export class BefundDokumentSortierung {
    be_id_1: number;
    be_id_2: number;
    sortierung_1: number;
    sortierung_2: number;
}
